import { Action } from "redux";
import isObject from "lodash/isObject";

export const isAction = (action: unknown): action is Action =>
    isObject(action) && "type" in action;
